import { Navigate } from "react-router";
import { useStateValue } from '../context/StateValueContext';
import { PERMISSIONS } from '../constants/permissions';


function FirstPage() {
  const [{ user }] = useStateValue();

  if (!user || !user.permissions || !Array.isArray(user.permissions)) {
    return <Navigate to="/signin" />;
  }
  return user.permissions.includes(PERMISSIONS.DASHBOARD) ? <Navigate to="/dashboard" /> : <Navigate to="/disputes" />;
}

export default FirstPage;
